import { useEffect } from 'react';
import { useNotification } from '@/context/notificationProvider';

interface Notification {
  classname?: string;
  message?: any;
  textColor?: string;
  color?: string;
  icon?: any;
  showUndoButton?: boolean;
  revertAddressCard?: () => void;
  setNotificationMessage?: any;
  notificationMessage?: any;
  isError: boolean;
  closeFlag?: any;
}

const Notification: React.FC<Notification> = ({
  classname,
  message,
  textColor,
  color,
  icon,
  showUndoButton,
  revertAddressCard,
  setNotificationMessage,
  notificationMessage,
}) => {
  const { showNotification } = useNotification();
  const handleClose = () => {
    if (setNotificationMessage) {
      setNotificationMessage('');
      showNotification('');
    }
  };

  useEffect(() => {
    const notificationTimeout = setTimeout(() => {
      if (setNotificationMessage) {
        setNotificationMessage('');
        showNotification('');
      }
    }, 5000);

    return () => clearTimeout(notificationTimeout);
  }, [notificationMessage, showNotification]);

  return (
    <section className={`flex items-center justify-between gap-x-2 ${color} rounded-md px-2 py-1 pl-1 ${classname}`}>
      <section className="flex items-center gap-x-2">
        <section>{icon}</section>
        <section>
          <p className={`${textColor} font-medium leading-6`}>{message}</p>
        </section>
      </section>
      <section className="flex justify-evenly gap-x-2">
        {showUndoButton && (
          <button
            type="button"
            className="rounded border bg-white px-3 py-1 pr-2 font-medium leading-6 text-black underline hover:bg-green-300"
            onClick={revertAddressCard}
          >
            Undo
          </button>
        )}
        <button type="button" className="mx-2 text-black" onClick={handleClose}>
          &#x2715;
        </button>
      </section>
    </section>
  );
};

export default Notification;
